<section class="pricing-section">
    <div class="container">
      <div class="section__header">
        <h2 class="section__title">Planes diseñados para cada etapa de tu negocio</h2>
        <p class="section__subtitle">
          Elige el plan que mejor se adapte a tus necesidades y comienza a transformar tu comunicación digital hoy mismo.
        </p>
      </div>
  
      <!-- Pricing Table (Desktop) -->
      <div class="pricing-table" [class.hidden]="showMobileCards">
        <div class="pricing-table__row pricing-table__header">
          <div class="pricing-table__cell pricing-table__cell--feature">Plan</div>
          <div class="pricing-table__cell pricing-table__cell--plan" *ngFor="let plan of plans">
            <div class="pricing-plan" [class.pricing-plan--popular]="plan.isPopular">
              <div class="pricing-plan__badge" *ngIf="plan.isPopular">Más popular</div>
              <h3 class="pricing-plan__title">{{ plan.title }}</h3>
              <div class="pricing-plan__price">
                <span class="pricing-plan__amount" *ngIf="plan.price.startsWith('$')">{{ plan.price }}</span>
                <span class="pricing-plan__amount" *ngIf="!plan.price.startsWith('$')">${{ plan.price }}</span>
                <span class="pricing-plan__period" *ngIf="plan.period">{{ plan.period }}</span>
              </div>
              <button class="pricing-plan__cta" [class.pricing-plan__cta--outline]="plan.ctaOutline">{{ plan.ctaText }}</button>
            </div>
          </div>
        </div>
  
        <!-- Feature rows -->
        <ng-container *ngFor="let featureType of ['Interacciones', 'Canales', 'Analítica', 'Integraciones', 'Soporte']">
          <div class="pricing-table__row">
            <div class="pricing-table__cell pricing-table__cell--feature">
              <div class="feature-label">
                <i class="bi {{ featureType === 'Interacciones' ? 'bi-chat' : 
                    featureType === 'Canales' ? 'bi-broadcast' : 
                    featureType === 'Analítica' ? 'bi-graph-up' : 
                    featureType === 'Integraciones' ? 'bi-puzzle' : 
                    featureType === 'Soporte' ? 'bi-headset' : '' }}"></i>
                <span>{{ featureType }}</span>
              </div>
            </div>
            
            <div class="pricing-table__cell" *ngFor="let plan of plans">
              <ng-container *ngFor="let feature of plan.features">
                <ng-container *ngIf="feature.name === featureType">
                  <!-- Si tiene valor simple -->
                  <span *ngIf="feature.value && !feature.items">{{ feature.value }}</span>
                  
                  <!-- Si tiene múltiples elementos -->
                  <ng-container *ngIf="feature.items">
                    <span class="feature-item" *ngFor="let item of feature.items">
                      <i class="bi bi-check-circle-fill feature-item__icon"></i>
                      {{ item }}
                    </span>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
  
      <!-- Pricing Cards (Mobile) -->
      <div class="pricing-cards" [class.hidden]="!showMobileCards">
        <div class="pricing-card" *ngFor="let plan of plans" [class.pricing-card--popular]="plan.isPopular">
          <div class="pricing-card__badge" *ngIf="plan.isPopular">Más popular</div>
          <div class="pricing-card__header">
            <h3 class="pricing-card__title">{{ plan.title }}</h3>
            <div class="pricing-card__price">
              <span class="pricing-card__amount" *ngIf="plan.price.startsWith('$')">{{ plan.price }}</span>
              <span class="pricing-card__amount" *ngIf="!plan.price.startsWith('$')">${{ plan.price }}</span>
              <span class="pricing-card__period" *ngIf="plan.period">{{ plan.period }}</span>
            </div>
          </div>
          <div class="pricing-card__features">
            <div class="pricing-card__feature" *ngFor="let feature of plan.features">
              <i class="bi bi-check-circle-fill pricing-card__feature-icon" *ngIf="feature.included"></i>
              <i class="bi bi-x-circle-fill pricing-card__feature-icon pricing-card__feature-icon--disabled" *ngIf="!feature.included"></i>
              
              <span>
                <strong>{{ feature.name }}:</strong> 
                <ng-container *ngIf="feature.value">{{ feature.value }}</ng-container>
                <ng-container *ngIf="feature.items">
                  {{ feature.items.join(', ') }}
                </ng-container>
              </span>
            </div>
          </div>
          <div class="pricing-card__actions">
            <button class="pricing-card__cta" 
                    [class.pricing-card__cta--primary]="!plan.ctaOutline" 
                    [class.pricing-card__cta--outline]="plan.ctaOutline">
              {{ plan.ctaText }}
            </button>
          </div>
        </div>
      </div>
  
    </div>
  </section>